module.exports = __webpack_public_path__ + "static/media/megabus-logo.15132b4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/megabus-logo.svg
// module id = 852
// module chunks = 0